/* Counterparty Multi-legs */

import { connect } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { createStructuredSelector } from 'reselect'
import { TradingEntity, SettlementVenue, NegotiationDetail, EntityStatus } from 'api'
import { Locale, Translation } from 'locale'
import { TradingEntityWithAliasHelper } from 'model'
import { createAuthorisedUserSelector } from 'selectors/connectionSelectors'
import { createChildOrParentIncomingNegotiationClearingHouseIdSelector } from 'selectors/negotiations'
import {
  CounterpartyFilter,
  createCounterpartyListSelector,
  createTradingEntityWithOptionalAliasGetterSelector
} from 'selectors/tradingEntitySelectors'
import { Nullable } from 'utils'
import { ComboboxProps, Combobox } from 'view/components/options'

export interface CounterpartyMultiLegComboboxProps extends ComboboxProps<TradingEntity, string> {
  filters: CounterpartyFilter[]
  settlementVenue: Nullable<SettlementVenue>
  negotiationDetail: NegotiationDetail
}

const filtersSelector = (_: {}, props: CounterpartyMultiLegComboboxProps): CounterpartyFilter[] => props.filters

const counterpartyMultiLegNegotiationDetailSelector = (_: {}, props: CounterpartyMultiLegComboboxProps) => props.negotiationDetail
const counterpartyMultiLegFundIdSelector = (_: {}, props: CounterpartyMultiLegComboboxProps) => props.filters[0]?.fundId ?? null
const counterpartyMultiLegSettlementVenueSelector = (_: {}, props: CounterpartyMultiLegComboboxProps) => props.settlementVenue

const counterpartyMultiLegMapStateToProps = createStructuredSelector({
  optionKeys: createCounterpartyListSelector(
    filtersSelector,
    counterpartyMultiLegSettlementVenueSelector,
    createChildOrParentIncomingNegotiationClearingHouseIdSelector(counterpartyMultiLegNegotiationDetailSelector),
    createSelector([createAuthorisedUserSelector()], user => user.organisationId)
  ),
  getOption: createTradingEntityWithOptionalAliasGetterSelector(counterpartyMultiLegFundIdSelector, () => true)
})

export const CounterpartyMultiLegCombobox = connect(counterpartyMultiLegMapStateToProps, null, null, { forwardRef: true })(
  (Combobox as any) as React.ComponentType<CounterpartyMultiLegComboboxProps>
)

CounterpartyMultiLegCombobox.defaultProps = {
  getOptionText: TradingEntityWithAliasHelper.getName,
  getOptionDisabled: tradingEntity => tradingEntity.status === EntityStatus.DISABLED,
  noItemsText: Locale.translate(Translation.SC_N_COUNTERPARTIES, { count: 0 })
}
